/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import NinusiSeikyuService from "../../service/master/ninusiseikyu/ninusiSeikyuService"
import { 荷主請求マスタ } from "../../service/master/ninusiseikyu/TNinusiSeikyu"
import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 荷主請求検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const NinusiSeikyuSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    ninusiName?: string
    setNinusi: (value: 荷主請求マスタ) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [荷主名, set荷主名] = useState<string>()

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: { 荷主名?: string }) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new NinusiSeikyuService().getList({
        // 検索は略称
        荷主略称1: searchCondition?.荷主名 ?? 荷主名,
      })

      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: 荷主請求マスタ) => {
    props.setNinusi(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      console.log(props)
      //表示時
      // 荷主コードが設定されている場合、その荷主コードで検索
      if (!wjcCore.isNullOrWhiteSpace(props.ninusiName ?? "")) {
        set荷主名(props.ninusiName)
        search({ 荷主名: props.ninusiName })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set荷主名("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "荷主請求マスタ検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <ul className="list-cmn">
                <li className="list-cmn  d-flex">
                  <TextInput
                    style={{ width: "30rem" }}
                    id="荷主名"
                    name="荷主名"
                    value={荷主名}
                    setValue={set荷主名}
                    maxLength={100}
                    placeholder="荷主名"
                  />
                </li>
              </ul>
            </Col>
            {/* </Row>
          <Row> */}
            <Col className="text-end mb-2">
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault()
                  search()
                }}>
                <FontAwesomeIcon icon={faSearch} />
                検索
              </Button>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="荷主品名ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<荷主請求マスタ>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="荷主CD"
                binding="荷主コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={300}
                header="荷主名"
                binding="荷主略称1"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="表紙CD"
                binding="表紙分割コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={250}
                header="表紙名"
                binding="表紙名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={"*"}
                header="備考"
                binding="備考"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default NinusiSeikyuSearchModal
